import { useContext } from 'react'

import { RiskHeadersContext } from './risk-headers.context'

export const useRiskHeaders = () => {
  const context = useContext(RiskHeadersContext)

  if (!context) {
    throw new Error('useRiskHeaders must be used within a RiskHeadersContext')
  }

  return context
}
